
import ProductListItem from './components/common/product_list_item'

const CategoryView = (props) => {

  const { addItemToCart, business, categories, category, hideZero, optionsFirst,
    removeItem,
    setItemQuantity,
    selectedMenu,
    pushCategory,
    popCategory,
    setSelectedCategory,
    setSelectedProduct,
    setSelectedService } = props;

 React.useEffect(() => {
    //console.log("useEffect", location.state, props)

    // setCurrentCategory(category)
    // setCurrentCategories(categories)

  }, [categories, category]);

  const _productIsOffer = (product) => {
    // if the product id is in an offer in the location
    if (selectedMenu.Location == null || selectedMenu.Location.Campaigns == null) {
      return false
    }
    let found = selectedMenu.Location.Campaigns.find((offer) => offer.productId == product.id)

    return found
  }

  const isVisible = (p) => {

    if (hideZero && p.managed === true && p.quantity <= 0) {
      // product inventory is managed
      return false
    }

    return p.available === true //&& p.restricted != true
  }

  const titleElement = () => {
    if (category.button != "") {
      //console.log("titleElement return button")
      return (
        <h3 className="mt-3 col-md-12 open-category-button centered mx-2" onClick={() => popCategory()}>
          <div className="space-evenly" >

            <span className="category-expander" onClick={() => popCategory()}  >
              <i className="fa fa-chevron-left fa-2z" aria-hidden="true"  ></i>
            </span>

            <img src={category.button} />
          </div>

        </h3>
      )

    }

    let fsize = Math.max(10, Math.min(40, 40 - (category.name.length - 4)))

    return (
      <h3 className="mt-3 col-md-12 category-header">
        <div className="py-2">

          <span className="category-expander" onClick={() => popCategory()} style={{
            marginRight: 5
          }}>
            <i className="fa fa-chevron-left fa-2x" aria-hidden="true" style={{ color: '#222' }}></i>
          </span>

          <span style={{
            fontSize: fsize
          }}>
            {category.name} <br />

          </span>
          <span>
            {category.description}
          </span>
        </div>

      </h3>
    )
  }

  const _styleForCategoryScrollMenu = () => {
    /*   if (currentCategory) {
        return {
          curser: 'pointer',
          position: 'sticky',
          top: '0%',
          zIndex: 10
        }
      } */
    return {
      curser: 'pointer'
    }
  }

  const _subCategoryScrollMenu = (category, currentCategory) => {
    if (category.Categories != null && category.Categories.length > 0 && currentCategory != null) {
      return (
        <div className="centered horizontal-scrollmenu category-scroll-menu" style={_styleForCategoryScrollMenu()}>
          {category.Categories.map((subCategory, i) => {
            let classes = "category-scroll-menu-item"
            if (subCategory.id == currentCategory.id) {
              classes += " selected-category"
            }

            return (
              <div key={i} onClick={() => pushCategory(subCategory)} className={classes} >
                {subCategory.name}
              </div>
            )
          })}
        </div>
      )
    }
    return <></>
  }

 // console.log("category", category.name, category.Categories, category.Products)

  const firstCategoryWithProducts = (category) => {
    if (!category.Products || category.Products.length == 0) {
      return null
    }

    if (category.Products.length > 0) {
      return category
    }
    for (let i = 0; i < category.Categories.length; i++) {
      let subCategory = category.Categories[i]

      return firstCategoryWithProducts(subCategory)
    }
    return null
  }

  const firstCategoryWithServices = (category) => {
    if (!category.Services || category.Services.length == 0) {
      return null
    }
    if (category.Services && category.Services.length > 0) {
      return category
    }
    for (let i = 0; i < category.Categories.length; i++) {
      let subCategory = category.Categories[i]

      return firstCategoryWithServices(subCategory)
    }
    return null
  }

  let products = category.Products ? category.Products.filter((p) => isVisible(p)) : []
  let services = category.Services ? category.Services.filter((s) => isVisible(s)) : []

  let currentCategory = category

  console.log("category", category.id, category.category_id, category.name, products, services)
  
  // if the products list is empty and there are sub categories
  // show the products of the first sub category
  if (products && products.length == 0 && category.Categories && category.Categories.length > 0) {
    currentCategory = firstCategoryWithProducts(category)

    if (currentCategory != null) {
      products = currentCategory.Products.filter((p) => isVisible(p))
    } else {

    }
  }

  // similarly for services
  if (services && services.length == 0 && category.Categories && category.Categories.length > 0) {
    let serviceCategory = firstCategoryWithServices(category)

    if (serviceCategory != null) {
      services = serviceCategory.Services.filter((s) => isVisible(s))
    }
  }

  const sectionHeader = (name) => {
    if (products && products.length > 0 && services && services.length > 0) {
      return <h5 className="mt-3 mb-2">{name}</h5>
    }
    return <></>
  } 


  return (<div id={`category_${category.name}`} className=" " >

    {titleElement()}

    {/* sub category buttons */}
    {_subCategoryScrollMenu(category, currentCategory)}

    <div id={`category_content_${category.id}`}
      className="category-content shadow-sm mb-1 px-1 centered">

      {/* Products Section */}
      {products.length > 0 && (
        <>
          {sectionHeader("Products")}
          <div className="product-item-grid">
            {products.map((product, i) => {
              let isOffer = _productIsOffer(product)

              let image = product.photo
              if (image == null || image == "") {
                image = business.photo
              }

              return (<ProductListItem
                key={`product-${i}`}
                product={product}
                categories={categories}
                id={product.id}
                image={image}
                title={product.name}
                price={product.price}
                hasOrdering={true}
                priceUnit='$'
                isOffer={isOffer}
                getValue={(args) => {
                  console.log("getValue add to cart", product.id, args);
                  if (args.quantity === 1) {
                    // make a copy of the object
                    let newItem = Object.assign({}, product);
                    newItem.quantity = 1
                    newItem.menu_id = product.menu_id || selectedMenu.id
                    addItemToCart(newItem, args);
                  } else if (args.quantity === 0) {
                    removeItem(product, args);
                  } else {
                    setItemQuantity(product, args.quantity);
                  }

                }}
                setSelectedProduct={setSelectedProduct}
                detailColour={'#F1AD3E'}
                optionsFirst={optionsFirst}
              />)
            })}
          </div>
        </>
      )}

      {/* Services Section */}
      {services.length > 0 && (
        <>
          {sectionHeader("Services")}
          <div className="product-item-grid">
            {services.map((service, i) => {
              let isOffer = _productIsOffer(service)

              let image = service.photo
              if (image == null || image == "") {
                image = business.photo
              }

              return (<ProductListItem
                key={`service-${i}`}
                product={service}
                categories={categories}
                id={service.id}
                image={image}
                title={service.name}
                price={service.price}
                hasOrdering={true}
                priceUnit='$'
                isOffer={isOffer}
                getValue={(args) => {
                  console.log("getValue add to cart", service.id, args);
                  if (args.quantity === 1) {
                    // make a copy of the object
                    let newItem = Object.assign({}, service);
                    newItem.quantity = 1
                    newItem.menu_id = service.menu_id || selectedMenu.id
                    addItemToCart(newItem, args);
                  } else if (args.quantity === 0) {
                    removeItem(service, args);
                  } else {
                    setItemQuantity(service, args.quantity);
                  }

                }}
                setSelectedProduct={setSelectedService}
                detailColour={'#F1AD3E'}
                optionsFirst={optionsFirst}
              />)
            })}
          </div>
        </>
      )}



    </div>

  </div>)
}

export default CategoryView